export var DebugLevel;

/**
 * Включает режим отладки
 * _am_debug - флаг для отладки метрик
 */
(function (DebugLevel) {
  DebugLevel["NONE"] = "";
  DebugLevel["NORMAL"] = "1";
  DebugLevel["FULL"] = "2";
})(DebugLevel || (DebugLevel = {}));
var detectDebugMode = function detectDebugMode() {
  var _ref;
  var debugQuery = new URLSearchParams(window.location.search).get('_am_debug');
  var debugEnv = process.env.NODE_ENV !== 'production' ? DebugLevel.NORMAL : null;
  return (_ref = debugQuery !== null && debugQuery !== void 0 ? debugQuery : debugEnv) !== null && _ref !== void 0 ? _ref : false;
};
export var debugLevel = typeof window !== 'undefined' && detectDebugMode();